import { Colors, Services } from '@sigma-frontend-libs/commons'

import { components, icons } from '@/utils'

import { serviceNameKebabCase, serviceNameViaPoint, urlShortenerSettingsDomainsStates } from '@/components/services/url-shortener-settings/domains/utils'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderName(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value.name,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.name`),
        icon: urlShortenerSettingsDomainsStates[this.value.state].icon,
        color: urlShortenerSettingsDomainsStates[this.value.state].color,
        iconTooltip: this.getTranslate(`${serviceNameViaPoint}.states.${this.value.state}`),
        copy: true,
        to: {
          name: `${serviceNameViaPoint}.single`,
          params: { id: this.value.id }
        }
      }
    }
  )
}
function renderTxt(h) {
  if (this.viewport.size.width > 600) {
    return h(
      sticker,
      {
        props: {
          value: this.value.txt,
          label: this.getTranslate(`${serviceNameViaPoint}.labels.txt`),
          icon: icons.text_fields,
          color: Colors.grey,
          copy: true
        }
      }
    )
  }
}
function renderOwner(h) {
  if (this.viewport.size.width > 480) {
    return h(
      owner,
      {
        props: {
          value: this.value,
          copy: true
        }
      }
    )
  }
}

function renderInfo(h) {
  return h(
    'div',
    {
      class: {
        [`${serviceNameKebabCase}-item__info`]: true,
        [`${serviceNameKebabCase}-item__info--admin`]: this.canGetUsers
      }
    },
    [
      renderName.call(this, h),
      renderTxt.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}
function renderCheckDNSAction(h) {
  if (this.canCheckDNS) {
    return h(
      components['list-item'],
      {
        props: {
          label: this.getTranslate(`${serviceNameViaPoint}.labels.checkDNS`),
          icon: icons.refresh,
          iconColor: Colors.primary
        },
        on: {
          click: () => {
            this.checkDNS(this.value.id)
          }
        }
      }
    )
  }
}
function renderActions(h) {
  return h(
    actions,
    {
      props: {
        value: this.value,
        service: Services['url-shortener-settings/domains'],
        actions: [ 'edit' ]
      },
      scopedSlots: {
        default: () => {
          return renderCheckDNSAction.call(this, h)
        }
      }
    }
  )
}
function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`service-template-item ${serviceNameKebabCase}-item`]: true,
        'hover-parent hover-parent--opacity': this.viewport.breakpoint.mdUp
      }
    },
    [
      renderInfo.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
